import { render, staticRenderFns } from "./sampleList.vue?vue&type=template&id=036f517a&scoped=true&"
import script from "./sampleList.vue?vue&type=script&lang=js&"
export * from "./sampleList.vue?vue&type=script&lang=js&"
import style0 from "./sampleList.vue?vue&type=style&index=0&id=036f517a&scoped=true&lang=css&"
import style1 from "./sampleList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f517a",
  null
  
)

export default component.exports